export const environment = {
    production: false,
    baseURL: 'https://api.eprintitsaas.org/public/',
    tbsBaseURL : 'https://api.eprintitsaas.org/graphql',
    webSocketUrl: 'wss://wss.eprintitsaas.org?apikey=7c3f738f-654b-4f19-bc23-b13410a7b244',
    // tinyMceKey: 'iynixb5kl1ce4r984f6gfb4q45s6yn30ze5yg9fnb116ocyr',
    apiKey: 'cweex23xieo2hznx2ln3hr8ru23crucl',
    guestRoleArn: 'arn:aws:iam::377667345683:role/RUM-Monitor-us-east-1-377667345683-9682485376661-Unauth',
    identityPoolId: 'us-east-1:ebc810af-e9f4-495b-8bba-7f9b54c4196a',
    applicationId: 'e0f7ca47-4996-4736-a856-a5de91c19deb',
    qrCodeURL: 'https://mobile.eprintitsaas.org',
    ssoAuthURL: 'https://api.eprintitsaas.org/auth',
    ssoRedirectURL: 'eprintitsaas.org/user/sign-in',
    paymentRedirectURL: 'eprintitsaas.org/',
    monerisScriptSource: 'https://gatewayt.moneris.com/chktv2/js/chkt_v2.00.js',
    monerisSetMode: 'qa',
    authorizeNetUrl: 'https://test.authorize.net/payment/payment',
    mobileRedirectURL: 'https://mobile.eprintitsaas.org',
    heartlandURL: 'https://pay.sandbox.realexpayments.com/pay',
    iPay88: 'https://payment.ipay88.com.my/epayment/entry.asp',
    googleLocationKey: "AIzaSyACmsOTOfTsh6bMvLSfeH8ixtTqn0ZTGO8",
    defaultLogoUrl: "https://eprintitsaas.org/logomainfile.png",
    statusWidgetUrl: 'https://api.dashboard.instatus.com/widget?host=eprintit.instatus.com&code=2ee052ba&locale=en',
    helpWidgetUrl: 'https://help-center.eprintitsaas.org/documentation/',
};
